import React from 'react';
import { useLocation } from 'react-router-dom';
import ManageClasses from '../Tenant-Admin/Class-Manager/ManageClasses';
import HODHeader from './components/Header';

const HODClassManager = () => {
  const location = useLocation();
  
  // Get data from location state or localStorage
  const tenantId = location.state?.tenantId || localStorage.getItem('tenantId');
  const userId = location.state?.userId || localStorage.getItem('userId');
  const organizationId = location.state?.organizationId || localStorage.getItem('organizationId');
  const userRole = location.state?.userRole || localStorage.getItem('userRole') || 'hod';
  const hodDepartmentId = location.state?.hodDepartmentId || null;

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-gray-900">
      <HODHeader />
      <div className="p-4">
        <ManageClasses 
          tenantId={tenantId}
          userId={userId}
          organizationId={organizationId}
          userRole={userRole}
          hodDepartmentId={hodDepartmentId}
          isHODView={true}
        />
      </div>
    </div>
  );
};

export default HODClassManager;